import create from "zustand";

export const useSocketConnectionStore = create((set) => ({
  isConnected: false,
  setConnected: (value) => set({ isConnected: value }),
}));
